import BarcodeRecorder from './BarcodeRecorder';

export default BarcodeRecorder;
